<template>
	<div v-if="formShow" class="signin-root">
		<loader :dialog="loading"></loader>

		<!-- Pill badge -->
		<span class="signin-badge">CEZ FITNESS CLUB</span>

		<!-- Titre & sous-titre -->
		<h2 class="signin-title">Bon retour !</h2>
		<p class="signin-subtitle">Connectez-vous pour accéder à votre espace</p>

		<!-- Formulaire -->
		<v-form ref="form" v-model="valid" lazy-validation class="mt-6">

			<v-text-field
				v-model="phone"
				:counter="9"
				:rules="phoneRules"
				label="Numéro de téléphone"
				required
				outlined
				dense
				prepend-inner-icon="mdi-phone-outline"
				color="blue darken-2"
				class="signin-field"
			></v-text-field>

			<v-text-field
				v-model="password"
				:rules="passwordRules"
				label="Mot de passe"
				required
				outlined
				dense
				prepend-inner-icon="mdi-lock-outline"
				:append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
				@click:append="() => (show = !show)"
				:type="show ? 'password' : 'text'"
				color="blue darken-2"
				class="signin-field"
			></v-text-field>

			<v-alert
				v-if="alert"
				type="error"
				dense
				border="left"
				colored-border
				text
				class="mb-4"
			>
				{{ alertMessage }}
			</v-alert>

			<v-btn
				:disabled="!valid"
				depressed
				large
				block
				class="connect-btn"
				@click="validate"
			>
				<v-icon left>mdi-login-variant</v-icon>
				Se connecter
			</v-btn>

		</v-form>

		<!-- Séparateur -->
		<div class="or-divider">
			<span class="or-line"></span>
			<span class="or-text">ou</span>
			<span class="or-line"></span>
		</div>

		<!-- Lien inscription -->
		<p class="no-account-text">Pas encore membre ?</p>
		<v-btn
			outlined
			block
			color="blue darken-2"
			class="register-btn"
			@click="removeForm()"
		>
			Créer un compte
		</v-btn>

	</div>
</template>

<script>
import service from "@/services";
import Loader from "../Loader.vue";
export default {
	components: { Loader },
	props: ["formShow"],
	data: () => ({
		show: true,
		alertMessage: "",
		alert: false,
		valid: true,
		phone: "",
		loading: false,
		phoneRules: [
			(v) => !!v || "Entrez un numéro de téléphone",
			(v) =>
				(v && v.length == 9) ||
				"Le numéro de téléphone doit avoir 9 chiffres",
		],
		password: "",
		passwordRules: [
			(v) => !!v || "Entrez votre mot de passe",
			(v) =>
				(v && v.length >= 8) ||
				"Le mot de passe doit avoir au moins 8 caractères",
		],
	}),

	methods: {
		validate() {
			if (this.$refs.form.validate()) {
				this.alert = false;
				this.loading = true;
				service
					.login({ phone: this.phone, password: this.password })
					.then((token) => {
						this.$store.dispatch("login", token);
						this.loading = false;
						this.$router.push("/admin");
					})
					.catch((err) => {
						this.alert = true;
						this.alertMessage = err
							? err.message
							: "Oops! Veuillez vérifier votre connexion internet";
						this.loading = false;
					});
			}
		},
		removeForm() {
			this.$emit("changeForm");
		},
	},
};
</script>

<style scoped>
.signin-root {
	font-family: Montserrat, sans-serif;
}

/* ─── Badge ─── */

.signin-badge {
	display: inline-block;
	padding: 5px 14px;
	background: linear-gradient(135deg, #c62828, #1565c0);
	color: #ffffff;
	font-size: 0.60rem;
	font-weight: 700;
	letter-spacing: 2.5px;
	text-transform: uppercase;
	border-radius: 50px;
	margin-bottom: 20px;
}

/* ─── En-tête ─── */

.signin-title {
	font-size: 1.9rem;
	font-weight: 800;
	color: #111827;
	margin: 0 0 6px;
	letter-spacing: 0.2px;
}

.signin-subtitle {
	font-size: 0.80rem;
	color: #9ca3af;
	margin: 0;
}

/* ─── Champs ─── */

.signin-field >>> .v-input__slot {
	border-radius: 10px !important;
}

/* ─── Bouton principal ─── */

.connect-btn {
	background: #c62828 !important;
	color: #ffffff !important;
	font-family: Montserrat, sans-serif;
	font-weight: 700;
	font-size: 0.85rem;
	letter-spacing: 2px;
	text-transform: uppercase;
	height: 50px !important;
	border-radius: 10px !important;
	box-shadow: 0 6px 22px rgba(198, 40, 40, 0.40) !important;
	transition: all 0.22s ease !important;
}

.connect-btn:hover:not(.v-btn--disabled) {
	box-shadow: 0 10px 30px rgba(198, 40, 40, 0.55) !important;
	transform: translateY(-2px);
}

.connect-btn.v-btn--disabled {
	background: #e5e7eb !important;
	color: #9ca3af !important;
	box-shadow: none !important;
}

/* ─── Séparateur ─── */

.or-divider {
	display: flex;
	align-items: center;
	gap: 12px;
	margin: 26px 0 20px;
}

.or-line {
	flex: 1;
	height: 1px;
	background: #e5e7eb;
	display: block;
}

.or-text {
	font-size: 0.68rem;
	font-weight: 700;
	color: #c4c4c4;
	letter-spacing: 1.5px;
	text-transform: uppercase;
}

/* ─── Section inscription ─── */

.no-account-text {
	font-size: 0.80rem;
	color: #6b7280;
	text-align: center;
	margin-bottom: 10px;
}

.register-btn {
	font-family: Montserrat, sans-serif !important;
	font-weight: 600 !important;
	letter-spacing: 1px !important;
	border-radius: 10px !important;
	height: 46px !important;
}
</style>
